import { MathJax, MathJaxContext } from "better-react-mathjax";
const NaiveBayes = () => {
    return(
        <div className="p-2 lg:px-3 overflow-hidden">
            <div className="lg:mx-0 lg:max-w-none overflow-hidden">
                {/* <p className="text-base font-semibold leading-7 text-teal-400">Naive Bayes</p> */}
                <h1 className="mt-2 text-xl font-bold tracking-tight text-teal-500">Naive Bayes Classifier</h1>

                <div className="mt-5 grid max-w-xl text-sm md:text-base text-justify grid-cols-1 gap-5 leading-7 text-gray-700 lg:max-w-none ">
                    <p>
                    Naive Bayes Classifier is a machine learning algorithm broadly used for classifiation. 
                    It's named as 'Naive' because it assumes that all the attributes given in the date are independent of each other, meaning the probability of one attribute does not affect the others. 
                    And the word 'Bayes' refers to this method's basis in Bayes' Theorem.
                    </p>
                    <p>
                       Bayes' Theorem is defined as : <br/>
                       <MathJaxContext>
                        <MathJax>
                            {`\\( P(y \\mid X) = \\frac{P(X \\mid y) \\cdot P(y)}{P(X)} \\)`}
                        </MathJax>
                       </MathJaxContext>
                        <br/>
                        Where : 
                        
                    </p>
                </div>
            </div>
        </div>
    )
}

export default NaiveBayes;

